import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from "react-router-dom"; 
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "bootstrap/dist/css/bootstrap.min.css";

(function () {
  let devtoolsOpen = false;
  const threshold = 160;

  const checkDevTools = () => {
      const widthDiff = window.outerWidth - window.innerWidth;
      const heightDiff = window.outerHeight - window.innerHeight;
      if (widthDiff > threshold || heightDiff > threshold) {
          devtoolsOpen = true;
          console.clear();  // Limpia la consola
          alert("No puedes inspeccionar esta página."); // Muestra una alerta
          window.location.href = "https://www.google.com"; // Redirige
      } else {
          devtoolsOpen = false;
      }
  };

  setInterval(checkDevTools, 1000);
})();

document.addEventListener("contextmenu", (event) => event.preventDefault());

document.addEventListener("keydown", (event) => {
  if (
      event.key === "F12" || 
      (event.ctrlKey && event.shiftKey && event.key === "I") || 
      (event.ctrlKey && event.shiftKey && event.key === "J") || 
      (event.ctrlKey && event.key === "U")
  ) {
      event.preventDefault();
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>

    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
